'use client';

import '@web/utils/fbc';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { LazyMotion } from 'motion/react';
import { PropsWithChildren, useEffect } from 'react';

import { useIsWebview } from '@flipster/features/src/shared/webview';
import { useOverlay, type OverlayProps } from '@flipster/overlay';
import { consentBunja } from '@flipster/utils/consent/state';
import { datadogInit } from '@flipster/utils/datadog';
import { getServerEnv, isBuild, isVercelLive } from '@flipster/utils/env-helper';
import segment from '@flipster/utils/segment';
import { getSegmentKey } from '@flipster/utils/segment/config';

import { CookiePopup } from './_layout/cookie-popup';

segment.load(getSegmentKey('web', getServerEnv()));

if (isBuild && !isVercelLive) {
  datadogInit({
    rum: datadogRum,
    logs: datadogLogs,
    service: 'prex-frontend-nextjs',
    applicationId: '33561c12-5347-40f5-b2b6-b0fb60ea0a18',
    clientToken: 'pub2db2647312d281299307d81d032af56b',
    env: getServerEnv(),
    version: process.env.NEXT_PUBLIC_VERSION ?? 'test',
    sessionReplaySampleRate: 33,
    beforeSend(event) {
      if (event.type === 'error') {
        // PiP 으로 인해서 무조건 발생할수 있는 에러는 제외
        if (event.error.message.includes('DocumentPictureInPicture')) return false;
        // #418 에러는 유의미한 에러는 아니라 제외 - Hydration error, 개발시 최대한 수정 필요
        if (event.error.message.includes('Minified React error #418')) return false;
      }
      return true;
    },
  });
}

// https://prextech.slack.com/archives/C0AQYAXTJ8N/p1776155651914039?thread_ts=1775551211.245739&cid=C0AQYAXTJ8N
// cookie popup 임시 비활성화
// oxlint-disable-next-line no-unused-vars
const ConsentPopup = () => {
  const overlay = useOverlay();
  const { isConsentRequiredAtom } = useBunja(consentBunja);
  const isVisible = useAtomValue(isConsentRequiredAtom);
  const isWebview = useIsWebview();
  useEffect(() => {
    if (isVisible && !isWebview) {
      overlay.open(({ close }: OverlayProps) => <CookiePopup onClose={close} />, { slot: 'cookie-popup' });
    }
  }, [overlay, isVisible, isWebview]);
  return null;
};

const Template = ({ children }: PropsWithChildren) => {
  return (
    <LazyMotion features={() => import('motion/react').then(({ domAnimation }) => domAnimation)} strict>
      {children}
      {/* <ConsentPopup /> */}
    </LazyMotion>
  );
};

export default Template;
